/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RemoveBrandHeroImageRequest} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'
import {RemoveBrandHeroImageResponse} from '@cash-web/protos/squareup/cash/local/v1/seller/cash_app_local_seller_service.pb'


export const removeBrandHeroImage = (request: RemoveBrandHeroImageRequest, options?: CashRequestOptions) => post<RemoveBrandHeroImageRequest, RemoveBrandHeroImageResponse>("/2.0/cash/remove-brand-hero-image", request, {...options, rejectOnError: true })